module.exports = __webpack_public_path__ + "static/loading.5bfb09d5.gif";